// Core packages
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Third party packages
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { IUser } from 'src/app/shared/models/user/user.interface';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SidenavService } from 'src/app/shared/services/sidenav.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  loggedUser: IUser;
  currentGlobal: any;
  currentRoleType = "";
  isIPICompany = false;
  isDemoRoma = false;

  /**
   * Class constructor
   */
  constructor(
    private sidenavService: SidenavService,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    public configService: ConfigService,
  ) { }

  /**
   * Init component
   *
   * @returns undefined
   */
  ngOnInit(): void {
    this.currentGlobal = window;
    this.lang = this.translateService.currentLang;
    if (this.activatedRoute.params) {
      const paramsSubscription = this.activatedRoute.params.subscribe(
        res => {
          if (res.lang) {
            this.lang = res.lang;
          }
        }
      );
      this.subscriptions.push(paramsSubscription);
    }
    // Subscribe to logged user data
    const loggedUserSubscription = this.authService.loggedUser$.subscribe(
      (user: any) => {
        this.loggedUser = user;
        if (this.loggedUser) {
          // current role
          const currentRole = this.loggedUser.userRoles.find((obj: any) => {
            return (
              obj._id.toString() ===
              this.authService.loggedUserRequestedRole$.getValue().toString()
            );
          });
          this.currentRoleType = currentRole.type;
        }
      }
    );
    this.subscriptions.push(loggedUserSubscription);

    this.authService.loggedUserRequestedRoleObj$.subscribe(
      (res: any) => {
        if (
          res && 
          res.company &&
          res.company._id
        ) {
          if (res.company._id === '6377485ebe9c226e840daad9') {
            this.isIPICompany = true;
          } else if (res.company._id === '699c1015dff37469e86f1743') {
            this.isDemoRoma = true;
          }
        }
      }
    )
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Toggle left sidenav
   *
   * @since 1.0.0
   */
  toggleSidenav(): void {
    this.sidenavService.toggle();
  }

  /**
   * Log user out deleting his JWT
   *
   * @since 1.0.0
   */
  onLogout(): void {
    this.authService.logout(true);
  }

  /**
   * Redirect to user detail
   *
   * @since 1.0.0
   */
  onViewProfile(): void {
    const userId = this.loggedUser._id;
    this.router.navigate([this.lang, 'app', 'users', 'detail', userId]);
  }

  /**
   * Redirect user to the same current page but with the new
   * language
   *
   * @since 1.0.0
   */
  onSelectLang(newLang: string): void {
    let actualRoute = this.router.url;
    if (actualRoute[0] === '/') {
      actualRoute = this.router.url.substr(1);
    }
    const newRouteAry = actualRoute.split('/');
    newRouteAry[0] = newLang;
    const newUrl = newRouteAry.join('/');
    this.router.navigateByUrl(newUrl);
  }

}
